export class ErrorDetail {
    title: string;
    location: string;
    message: string;
    activityId: string;
    timestamp: string;
    error: Error;
}

export class DataMinerUiError {
    activityId: string;
    code: string;
    message: string;
    detailedMessage: string;
    timestamp: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/error-handling/error-detail.model.ts